module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAB1JREFUGBljZJj9/z8DEYCJCDVgJaMK8YYU0cEDADK1Aq12ptwdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/exercise.png
// module id = 144
// module chunks = 7